// Curated local guides shown on each property detail page, keyed by city.
export const CITY_GUIDES = {
  "Canyon Lake": {
    intro: "Nestled between the Guadalupe River and the shores of Canyon Lake — the heart of the Texas Hill Country.",
    dining: [
      { name: "Tavern in the Gruene", desc: "Live music, cold drinks and Texas comfort food in historic Gruene." },
      { name: "Pat's Place", desc: "Lakeside patio dining — a local favorite for burgers and sunset views." },
      { name: "The Old Coupland Inn (day trip)", desc: "Classic Hill Country dance hall and steakhouse." },
    ],
    activities: [
      { name: "Canyon Lake boating & swimming", desc: "Rent a boat or paddleboard and spend the day on the water." },
      { name: "Guadalupe River tubing", desc: "The quintessential Hill Country float — outfitters minutes away." },
      { name: "Hill Country wineries", desc: "Dozens of tasting rooms along the nearby Wine Trail." },
    ],
    attractions: [
      { name: "Natural Bridge Caverns", desc: "Texas' largest show caverns — a must-see, 20 minutes away." },
      { name: "Gruene Historic District", desc: "Antiques, wine, and the oldest dance hall in Texas." },
      { name: "Schlitterbahn Waterpark", desc: "World-famous waterpark in nearby New Braunfels." },
    ],
  },
  "New Braunfels": {
    intro: "A charming German-rooted river town where the Comal and Guadalupe rivers meet.",
    dining: [
      { name: "Gristmill River Restaurant", desc: "Iconic riverside dining in a historic cotton-gin ruin in Gruene." },
      { name: "Naegelin's Bakery", desc: "The oldest bakery in Texas — grab a strudel before your float." },
      { name: "McAdoo's Seafood", desc: "Gulf seafood in a beautiful historic post-office building." },
    ],
    activities: [
      { name: "Comal River tubing", desc: "The world's shortest river makes for a perfect lazy float." },
      { name: "Landa Park", desc: "Spring-fed pool, paddle boats and a miniature train." },
      { name: "Schlitterbahn Waterpark", desc: "Consistently ranked among the best waterparks in the world." },
    ],
    attractions: [
      { name: "Gruene Hall", desc: "The oldest continually operating dance hall in Texas." },
      { name: "Natural Bridge Caverns", desc: "Guided cavern tours and an outdoor adventure park." },
      { name: "Historic Downtown", desc: "Boutique shopping and German heritage along Main Plaza." },
    ],
  },
  "San Antonio": {
    intro: "Big-city culture, historic missions and world-class dining — all within easy reach.",
    dining: [
      { name: "The Pearl District", desc: "A food-lover's hub of chef-driven restaurants and a weekend farmers market." },
      { name: "Mi Tierra Café", desc: "Legendary 24-hour Tex-Mex in Market Square." },
      { name: "Cured at Pearl", desc: "Acclaimed charcuterie and Hill Country fare." },
    ],
    activities: [
      { name: "The River Walk", desc: "Stroll or cruise the iconic waterway lined with cafés and shops." },
      { name: "Pearl & Museum Reach", desc: "Bike or walk the scenic extension to the Pearl." },
      { name: "Day trips to the Hill Country", desc: "Wineries, caverns and lake towns just north of the city." },
    ],
    attractions: [
      { name: "The Alamo", desc: "Texas' most famous historic landmark, downtown." },
      { name: "San Antonio Missions", desc: "A UNESCO World Heritage site of Spanish colonial missions." },
      { name: "San Antonio Zoo & Brackenridge Park", desc: "Family favorites in the heart of the city." },
    ],
  },
};

export const DEFAULT_GUIDE = CITY_GUIDES["Canyon Lake"];

export function getGuide(city) {
  return CITY_GUIDES[city] || DEFAULT_GUIDE;
}
